import React, { useEffect, useState } from "react";
import {
  addDoc,
  collection,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  where,
} from "firebase/firestore";
import { Link } from "react-router-dom";
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { db } from "../../firebase";
import { useAuth } from "../../auth/AuthContext";

export default function DocsListPage() {
  const { user } = useAuth();
  const [docs, setDocs] = useState([]);
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (!user?.uid) {
      setDocs([]);
      return undefined;
    }
    const q = query(
      collection(db, "docs"),
      where("ownerUid", "==", user.uid),
      orderBy("updatedAt", "desc")
    );
    return onSnapshot(q, (snap) => {
      setDocs(snap.docs.map((row) => ({ id: row.id, ...row.data() })));
    }, (error) => setStatus(error.message || "Failed to load docs"));
  }, [user?.uid]);

  const createDoc = async () => {
    if (!user?.uid) return;
    try {
      await addDoc(collection(db, "docs"), {
        title: "Untitled Quilt Doc",
        ownerUid: user.uid,
        blocks: [[{ kind: "text", text: "Start writing here." }]],
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
      setStatus("Doc created.");
    } catch (error) {
      setStatus(error.message || "Create failed");
    }
  };

  if (!user) {
    return <Box sx={{ p: 3 }}><Typography>Sign in to use docs.</Typography></Box>;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Stack spacing={2}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h4" fontWeight={800}>Quilt Docs</Typography>
          <Button variant="contained" onClick={() => void createDoc()}>Create doc</Button>
        </Stack>
        {!!status && <Typography color="text.secondary">{status}</Typography>}
        {docs.map((docItem) => (
          <Card key={docItem.id} variant="outlined">
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography fontWeight={700}>{docItem.title || "Untitled"}</Typography>
                  <Typography variant="caption" color="text.secondary">{docItem.id}</Typography>
                </Box>
                <Button component={Link} to={`/docs/${docItem.id}`} variant="outlined">Open</Button>
              </Stack>
            </CardContent>
          </Card>
        ))}
        {!docs.length && <Typography color="text.secondary">No docs yet.</Typography>}
      </Stack>
    </Box>
  );
}
